import {FC} from 'react';
import {styled, TextField} from '@mui/material';
import {changeContractRequestId, useContractRequestStore} from '../../stores/contract-request.store';

export const ContractRequestsSearchField: FC = () => {
  const {data: state} = useContractRequestStore();

  return (
    <StyledNumberField
      label="Поиск по номеру заявки"
      variant="outlined"
      size="small"
      type="number"
      onChange={changeContractRequestId}
      defaultValue={state.id}
    />
  );
};

const StyledNumberField = styled(TextField)({
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
  '& input[type=number]::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  '& input[type=number]::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
});
